import React, { useEffect } from "react";

// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");
// require('highcharts/highmaps')(Highcharts);
require("highcharts/modules/map")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);

function MapChart() {
  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderMapChart() {
      (async () => {
        const topology = await fetch(
          "https://code.highcharts.com/mapdata/countries/sa/sa-all.topo.json"
        ).then((response) => response.json());

        // Prepare demo data. The data is joined to map using value of 'hc-key'
        // property by default. See API docs for 'joinBy' for more info on linking
        // data and map.
        const data = [
          ["sa-4293",10],
          ["sa-tb", 11],
          ["sa-jz", 12],
          ["sa-nj", 13],
          ["sa-ri", 14],
          ["sa-md", 15],
          ["sa-ha", 16],
          ["sa-qs", 17],
          ["sa-hs", 18],
          ["sa-jf", 19],
          ["sa-sh", 20],
          ["sa-ba", 21],
          ["sa-as", 22],
          ["sa-mk", 23],
        ];

        // Create the chart
        Highcharts.mapChart(`mc-${id}`, {
          chart: {
            map: topology,
            backgroundColor: null,
            
          },

          title: {
            text: "",
          },

          mapNavigation: {
            enabled: true,
            buttonOptions: {
              enabled: false,
              verticalAlign: "top",
            },
          },

          credits: {
            enabled: false,
          },

          exporting: {
            enabled: false,
          },

          colorAxis: {
            min: 0,
          },

          series: [
            {
              
              dashStyle: 'dot',
              borderWidth: 1,
              data: data,
              name: "Random data",
              states: {
                hover: {
                  color: "#BADA55",
                },
              },
              dataLabels: {
                enabled: true,
                format: "{point.name}",
              },
            },
          ],
        });
      })();
    }
    renderMapChart();
  });
  return <div id={`mc-${id}`} style={{width: '85%', height: '485px'}}></div>;
}

export default MapChart;
